// frontend_react/src/components/Login.jsx
import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import { useLocation } from 'react-router-dom';

const Login = () => {
    // Stati Generali
    const [activeTab, setActiveTab] = useState('login');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [showReset, setShowReset] = useState(false);
    
    // Stati Form
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [registerData, setRegisterData] = useState({ name: '', email: '', password: '', confirmPassword: '' });
    const [resetEmail, setResetEmail] = useState('');

    // STATO PER EFFETTO ROLLOVER GOOGLE
    const [isGoogleHovered, setIsGoogleHovered] = useState(false);

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('status') === 'activated') {
            setMessage({ text: 'Account attivato! Ora puoi accedere.', type: 'success' });
        }
    }, [location]);

//    const googleLoginUrl = "http://localhost/unitestai/api/login_google_init.php";
    // const googleLoginUrl = "https://unitestai.massimilianosessa.it/api/login_google_init.php";
    const googleLoginUrl=`${process.env.REACT_APP_API_BASE_URL}/login_google_init.php`;

    // --- STILE DINAMICO PER IL BOTTONE GOOGLE ---
    const googleBtnStyle = {
        backgroundColor: isGoogleHovered ? '#3367D6' : '#4285F4',
        color: 'white',
        border: 'none',
        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
        transform: isGoogleHovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: isGoogleHovered ? '0 5px 15px rgba(66, 133, 244, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        fontWeight: '500'
    };

    // --- HANDLER: LOGIN ---
    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: 'Verifica credenziali...', type: 'info' });

        try {
            const response = await axios.post('/api_login_request.php', JSON.stringify(loginData));
            if (response.data.success) {
                setMessage({ text: 'Link di accesso inviato alla tua email!', type: 'success' });
            } else {
                setMessage({ text: response.data.message, type: 'danger' });
            }
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Errore di connessione.';
            setMessage({ text: errorMsg, type: 'danger' });
        }
    };

    // --- HANDLER: REGISTRAZIONE ---
    const handleRegisterSubmit = async (e) => {
        e.preventDefault();
        
        if (registerData.password !== registerData.confirmPassword) {
            setMessage({ text: 'Le password non coincidono!', type: 'danger' });
            return;
        }
        if (registerData.password.length < 8) {
            setMessage({ text: 'Minimo 8 caratteri.', type: 'danger' });
            return;
        }

        setMessage({ text: 'Registrazione in corso...', type: 'info' });

        try {
            const payload = {
                name: registerData.name,
                email: registerData.email,
                password: registerData.password
            };
            const response = await axios.post('/api_register.php', JSON.stringify(payload));
            
            if (response.data.success) {
                setMessage({ text: response.data.message, type: 'success' });
                setRegisterData({ name: '', email: '', password: '', confirmPassword: '' });
                setTimeout(() => setActiveTab('login'), 2000); 
            }
        } catch (err) {
            console.log("Errore:", err);
            let errorMsg = 'Errore registrazione.';
            if (err.response && err.response.data && err.response.data.message) {
                errorMsg = err.response.data.message;
            }
            setMessage({ text: errorMsg, type: 'danger' });
        }
    };

    // --- HANDLER: RESET PASSWORD ---
    const handleResetSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: 'Invio richiesta...', type: 'info' });

        try {
            const response = await axios.post('/api_forgot_password.php', JSON.stringify({ email: resetEmail }));
            
            if (response.data.success) {
                setMessage({ text: response.data.message, type: 'success' });
                setTimeout(() => {
                    setShowReset(false);
                    setMessage({ text: '', type: '' });
                    setResetEmail('');
                }, 4000);
            } else {
                setMessage({ text: response.data.message, type: 'danger' });
            }
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Errore di connessione.';
            setMessage({ text: errorMsg, type: 'danger' });
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center py-5" 
             style={{ background: 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)' }}>
            
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: '480px', width: '100%' }}>
                <div className="card-body p-4 p-md-5">
                    
                    {/* --- LOGO SVG NUOVO --- */}
                    <div className="text-center mb-4">
                        <svg width="100%"  viewBox="0 0 1000 300" style={{ height:"auto", maxWidth: '320px' }} xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path style={{fill: 'rgb(17, 160, 217)', strokeWidth: 1}} d="M 154.614 174.577 C 154.614 174.577 162.255 170.216 167.304 165.105 C 169.126 163.26 172.784 158.147 172.784 158.147 C 172.784 158.147 174.523 162.714 174.523 165.105 C 174.523 185.213 173.944 227.348 173.944 227.348 C 173.944 227.348 172.015 238.621 169.111 243.392 C 166.078 248.374 156.547 255.57 156.547 255.57 C 156.547 255.57 124.349 278.55 105.742 285.918 C 100.621 287.946 96.072 289.679 88.632 289.591 C 80.84 289.499 77.214 288.608 71.881 286.691 C 52.192 279.613 17.371 255.57 17.371 255.57 C 17.371 255.57 9.884 250.422 4.806 242.039 C 0.713 235.282 0.167 226.575 0.167 226.575 C 0.167 226.575 0.36 185.08 0.36 164.332 C 0.36 160.447 2.293 157.794 2.293 157.794 C 2.293 157.794 5.317 163.615 7.159 165.366 C 13.206 171.114 20.27 174.997 20.27 174.997 L 19.69 223.869 C 19.69 223.869 19.954 230.017 22.59 233.534 C 24.932 236.659 27.809 238.753 27.809 238.753 L 73.428 265.815 C 73.428 265.815 82.344 270.199 87.152 270.261 C 91.922 270.322 100.876 266.202 100.876 266.202 L 144.755 239.913 C 144.755 239.913 149.861 235.87 151.521 233.147 C 153.282 230.259 154.614 223.482 154.614 223.482 L 154.614 174.577 Z"></path>
                                <path style={{strokeWidth: 1, fill: 'rgb(255, 255, 255)'}} d="M 143.823 50.768 C 143.823 50.768 138.595 46.635 131.783 45.953 C 128.626 45.637 123.047 46.548 119.182 48.709 C 115.112 50.984 111.091 53.696 107.558 56.972 C 100.499 63.517 88.984 79.845 88.984 79.845 C 88.984 79.845 77.956 94.053 71.867 102.195 C 69.896 104.831 66.177 109.014 63.316 109.648 C 60.683 110.231 57.061 109.619 54.467 106.686 C 50.631 102.349 47.053 97.092 47.053 97.092 C 47.053 97.092 44.173 92.322 40.595 89.89 C 36.458 87.077 35.433 87.524 32.663 87.934 C 30.268 88.289 28.642 88.287 26.15 90.156 C 23.251 92.33 22.123 94.373 21.553 96.727 C 20.981 99.087 21.492 101.111 22.112 103.109 C 22.902 105.658 24.843 108.284 26.362 110.478 C 34.789 122.652 54.599 144.101 54.599 144.101 C 54.599 144.101 56.519 146.583 62.469 146.565 C 67.655 146.549 69.948 144.189 69.948 144.189 C 69.948 144.189 73.688 140.506 75.399 138.52 C 92.344 118.849 119.135 80.913 122.932 76.814 C 127.51 71.871 130.286 70.807 134.706 69.401 C 137.272 68.585 140.045 68.582 142.643 69.291 C 144.878 69.9 146.525 70.913 148.181 72.278 C 149.775 73.592 150.998 75.221 151.911 77.075 C 152.9 79.084 153.371 83.485 153.371 83.485 C 153.371 83.485 153.775 66.127 150.348 58.487 C 148.969 55.413 143.823 50.768 143.823 50.768 Z"></path>
                                <text style={{fill: 'rgb(12, 74, 118)', fontFamily: '"Gill Sans MT", sans-serif', fontSize: '138.4px', letterSpacing: '7.2px', textAnchor: 'middle', whiteSpace: 'pre', strokeWidth: 1}} x="-151.8" y="-57.93">
                                    <tspan x="597.31" y="156.854" style={{textTransform: 'uppercase', fontSize: '138.4px', wordSpacing: '0px', letterSpacing: '7.2px', strokeWidth: 1}}>UNITEST</tspan>
                                    <tspan style={{fontSize: '138.4px', wordSpacing: '0px', letterSpacing: '7.2px', strokeWidth: 1}}> </tspan>
                                    <tspan style={{fontWeight: 700, fontSize: '138.4px', wordSpacing: '0px', letterSpacing: '7.2px', strokeWidth: 1}}>AI</tspan>
                                </text>
                                <text style={{fill: 'rgb(242, 150, 43)', fontFamily: 'Arial, sans-serif', fontSize: '64.2px', fontWeight: 700, textTransform: 'uppercase', whiteSpace: 'pre', strokeWidth: 1}} x="199.256" y="233.359">next generation test</text>
                                <path style={{strokeWidth: 0.5, fill: 'rgb(12, 74, 118)'}} d="M 88.443 10.468 C 94.493 10.431 98.511 11.81 106.002 15.712 C 113.493 19.614 121.623 24.363 130.748 29.779 C 139.873 35.195 147.291 39.033 152.623 42.36 C 157.954 45.687 161.715 48.31 164.555 50.91 C 159.388 47.061 154.126 46.043 149.672 46.258 C 145.218 46.473 141.573 47.92 139.641 49 C 137.606 50.137 135.632 51.335 133.726 52.658 C 131.819 53.981 129.98 55.429 128.213 57.067 C 124.684 60.34 120.073 66.009 116.344 70.86 C 112.615 75.711 109.769 79.744 109.769 79.744 C 109.769 79.744 106.951 83.393 103.362 88.052 C 99.773 92.711 95.412 98.38 92.326 102.42 C 91.145 103.966 89.902 105.638 88.474 107.003 C 87.046 108.368 85.434 109.426 83.514 109.743 C 82.184 109.963 80.62 109.956 79.064 109.527 C 77.509 109.098 75.962 108.248 74.665 106.781 C 72.747 104.613 70.893 102.214 69.52 100.358 C 68.146 98.502 67.251 97.187 67.251 97.187 C 67.251 97.187 66.531 95.995 65.364 94.498 C 64.197 93.001 62.582 91.201 60.793 89.985 C 58.724 88.579 57.434 87.987 56.314 87.798 C 55.194 87.609 54.246 87.824 52.861 88.029 C 51.664 88.207 50.707 88.344 49.739 88.67 C 48.771 88.997 47.79 89.512 46.544 90.447 C 45.094 91.534 44.169 92.539 43.535 93.567 C 42.901 94.595 42.558 95.645 42.273 96.822 C 41.987 98.002 41.972 99.066 42.105 100.084 C 42.238 101.102 42.521 102.075 42.831 103.074 C 43.226 104.348 43.828 105.544 44.52 106.696 C 45.213 107.847 45.996 108.954 46.756 110.051 C 50.969 116.138 58.11 124.642 64.198 131.624 C 70.285 138.606 75.319 144.066 75.319 144.066 C 75.319 144.066 75.783 144.67 76.941 145.272 C 78.099 145.874 79.953 146.473 82.732 146.464 C 85.325 146.456 87.178 145.911 88.384 145.368 C 89.589 144.825 90.146 144.284 90.146 144.284 C 90.146 144.284 91.081 143.363 92.23 142.194 C 93.379 141.025 94.742 139.608 95.597 138.615 C 104.07 128.779 115.004 114.378 124.294 101.923 C 133.585 89.468 141.232 78.959 143.13 76.91 C 145.419 74.438 147.257 72.937 149.076 71.877 C 150.895 70.817 152.694 70.2 154.904 69.497 C 156.187 69.089 157.554 68.803 158.926 68.707 C 160.297 68.611 161.672 68.706 162.972 69.061 C 164.09 69.365 165.093 69.787 166.024 70.303 C 166.955 70.819 167.813 71.43 168.641 72.113 C 169.438 72.77 170.191 73.506 170.859 74.309 C 171.527 75.112 172.11 75.983 172.566 76.91 C 173.061 77.914 173.401 78.772 173.643 80.033 C 173.886 81.294 174.03 82.96 174.134 85.58 C 174.239 88.234 174.249 87.751 174.264 89.181 C 174.279 90.611 174.298 93.953 174.421 104.256 C 174.545 114.559 174.348 124.966 173.724 133.559 C 173.1 142.152 172.05 148.93 170.466 151.976 C 168.836 155.111 163.661 159.686 156.601 164.785 C 149.541 169.884 140.598 175.506 131.432 180.733 C 122.267 185.96 112.879 191.792 104.931 195.312 C 96.983 198.831 90.474 200.095 87.07 200.012 C 78.118 199.795 75.3 197.839 67.51 193.729 C 59.72 189.619 50.368 183.837 41.351 178.548 C 32.334 173.259 24.845 169.592 17.815 165.257 C 10.785 160.922 7.501 155.792 6.121 153.645 C 4.932 151.795 1.609 146.692 0.679 138.203 C -0.251 129.714 0.569 119.055 0.511 107.906 C 0.453 96.757 0.293 87.073 0.597 78.533 C 0.901 69.993 1.796 62.853 5.455 57.24 C 9.247 51.424 14.326 47.295 20.656 43.336 C 26.986 39.377 34.566 35.589 43.359 30.452 C 52.152 25.315 59.781 20.323 66.744 16.605 C 73.707 12.887 80.002 10.444 86.127 10.406 L 88.443 10.468 Z"></path>
                            </g>
                        </svg>
                    </div>

                    {message.text && (
                        <div className={`alert alert-${message.type} text-center shadow-sm border-0`} role="alert">
                            {message.text}
                        </div>
                    )}

                    {/* VISTA 1: RECUPERO PASSWORD */}
                    {showReset ? (
                        <div className="animate-fade-in">
                            <h4 className="text-center mb-2 fw-bold text-dark">Recupero Password</h4>
                            <p className="text-muted small text-center mb-4">
                                Inserisci la tua email. Se esiste, ti invieremo un link per creare una nuova password.
                            </p>
                            
                            <form onSubmit={handleResetSubmit}>
                                <div className="form-floating mb-3">
                                    <input 
                                        type="email" className="form-control" id="resetEmailInput" required 
                                        placeholder="nome@esempio.com"
                                        value={resetEmail} 
                                        onChange={(e) => setResetEmail(e.target.value)}
                                    />
                                    <label htmlFor="resetEmailInput">Email</label>
                                </div>
                                <button type="submit" className="btn btn-warning w-100 mb-3 fw-bold py-2 shadow-sm">Invia Link di Reset</button>
                                <button type="button" className="btn btn-light w-100 text-muted" onClick={() => setShowReset(false)}>
                                    Annulla e Torna al Login
                                </button>
                            </form>
                        </div>
                    ) : (
                        /* VISTA 2: LOGIN E REGISTRAZIONE */
                        <div className="animate-fade-in">
                            {/* PULSANTE GOOGLE */}
                            <a 
                                href={googleLoginUrl} 
                                className="btn w-100 mb-4 d-flex align-items-center justify-content-center py-2 rounded-3" 
                                style={googleBtnStyle}
                                onMouseEnter={() => setIsGoogleHovered(true)}
                                onMouseLeave={() => setIsGoogleHovered(false)}
                            >
                                <span className="bg-white rounded-1 d-flex align-items-center justify-content-center me-3" style={{width: '32px', height: '32px'}}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.64 9.20455C17.64 8.56636 17.5827 7.95273 17.4764 7.36364H9V10.845H13.8436C13.635 11.97 13.0009 12.9232 12.0477 13.5614V15.8195H14.9564C16.6582 14.2527 17.64 11.9455 17.64 9.20455Z" fill="#4285F4"/>
                                        <path d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5614C11.2418 14.1014 10.2109 14.4205 9 14.4205C6.65591 14.4205 4.67182 12.8373 3.96409 10.71H0.957275V13.0418C2.43818 15.9832 5.48182 18 9 18Z" fill="#34A853"/>
                                        <path d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957275C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957275 13.0418L3.96409 10.71Z" fill="#FBBC05"/>
                                        <path d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z" fill="#EA4335"/>
                                    </svg>
                                </span>
                                <span className="fw-bold">Continua con Google</span>
                            </a>

                            <div className="position-relative text-center mb-4">
                                <hr className="text-muted opacity-25" />
                                <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small text-uppercase fw-bold">oppure</span>
                            </div>

                            <div className="nav nav-pills nav-fill mb-4 bg-light p-1 rounded-3">
                                <button 
                                    className={`nav-link rounded-2 fw-semibold ${activeTab === 'login' ? 'active bg-white text-primary shadow-sm' : 'text-muted'}`} 
                                    onClick={() => setActiveTab('login')}
                                    style={{transition: 'all 0.2s'}}
                                >
                                    Accedi
                                </button>
                                <button 
                                    className={`nav-link rounded-2 fw-semibold ${activeTab === 'register' ? 'active bg-white text-success shadow-sm' : 'text-muted'}`} 
                                    onClick={() => setActiveTab('register')}
                                    style={{transition: 'all 0.2s'}}
                                >
                                    Registrati
                                </button>
                            </div>

                            <div className="tab-content">
                                {/* LOGIN FORM */}
                                {activeTab === 'login' && (
                                    <form onSubmit={handleLoginSubmit}>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                id="loginEmail" 
                                                placeholder="name@example.com"
                                                required 
                                                value={loginData.email} 
                                                onChange={(e) => setLoginData({...loginData, email: e.target.value})} 
                                                autoComplete="username"
                                            />
                                            <label htmlFor="loginEmail">Email</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                id="loginPassword" 
                                                placeholder="Password"
                                                required 
                                                value={loginData.password} 
                                                onChange={(e) => setLoginData({...loginData, password: e.target.value})} 
                                                autoComplete="current-password"
                                            />
                                            <label htmlFor="loginPassword">Password</label>
                                        </div>
                                        <button type="submit" className="btn btn-primary w-100 py-2 fw-bold shadow-sm">Accedi</button>
                                        
                                        <div className="text-center mt-3">
                                            <button type="button" className="btn btn-link text-decoration-none btn-sm text-muted" onClick={() => setShowReset(true)}>
                                                Password dimenticata?
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {/* REGISTER FORM */}
                                {activeTab === 'register' && (
                                    <form onSubmit={handleRegisterSubmit}>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="regName" 
                                                placeholder="Mario Rossi"
                                                required 
                                                value={registerData.name} 
                                                onChange={(e) => setRegisterData({...registerData, name: e.target.value})} 
                                                autoComplete="name"
                                            />
                                            <label htmlFor="regName">Nome Utente</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                id="regEmail" 
                                                placeholder="name@example.com"
                                                required 
                                                value={registerData.email} 
                                                onChange={(e) => setRegisterData({...registerData, email: e.target.value})} 
                                                autoComplete="email"
                                            />
                                            <label htmlFor="regEmail">Email</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                id="regPass" 
                                                placeholder="Password"
                                                required minLength="8"
                                                value={registerData.password} 
                                                onChange={(e) => setRegisterData({...registerData, password: e.target.value})} 
                                                autoComplete="new-password"
                                            />
                                            <label htmlFor="regPass">Password (min. 8)</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                id="regConfirm" 
                                                placeholder="Conferma Password"
                                                required minLength="8"
                                                value={registerData.confirmPassword} 
                                                onChange={(e) => setRegisterData({...registerData, confirmPassword: e.target.value})} 
                                                autoComplete="new-password"
                                            />
                                            <label htmlFor="regConfirm">Conferma Password</label>
                                        </div>
                                        <button type="submit" className="btn btn-success w-100 py-2 fw-bold shadow-sm">Crea Account</button>
                                    </form>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Login;